export default "__VITE_ASSET__8dabf952__"